import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

// window.apiAlcideUrlPrefix = "http://dh-server.fbk.eu:8080/Alcide/"
window.apiAlcideUrlPrefix = "/"
//window.apiAlcideUrlPrefix = "http://localhost:8080/Alcide/"



if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) )
{
    document.body.style.backgroundColor = "#fff"
    document.body.innerHTML ='<div class="container" style="background-color: #fff"><div class="row" id="header"><div class="one-twelve column" style="margin-top: 10%"><h1>Alcide</h1><h4>Un viaggio negli scritti di De Gasperi</h4></div><div class="one-twelve column" style="font-size:16px"><br/><h5 style="font-size:1.2em">Questo sito non è ottimizzato per piattaforme mobile come smartphone o tablet.</h5><h5 style="font-size:1.2em">Si consiglia l\'utilizzo utilizzando un laptop o un computer desktop.</h5></div></div></div>'

}else{
    ReactDOM.render(<App />, document.getElementById('root'));
}


registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js